<script setup lang="ts">
  import { useWindowSize } from '@vueuse/core';
  import template from './template.html?raw';
  import templateBa from './template-ba.html?raw';

  const props = withDefaults(
    defineProps<{
      html: string;
      iframe?: boolean;
    }>(),
    {
      iframe: true,
    },
  );

  const { width: windowWidth } = useWindowSize();

  const siteTheme = useSiteTheme();
  const projectConfig = useProjectConfig();
  const iframeRef = ref<HTMLIFrameElement>();
  const innerHtml = computed(() => (props.iframe ? decorateHtml(props.html) : props.html));

  if (process.client) {
    const bc = new BroadcastChannel('WebView:iframe');
    bc.onmessage = (message) => {
      if (message.data === 'click') {
        initIframe();
      }
    };
  }

  function decorateHtml(html: string) {
    let content = template;
    if (projectConfig.name === 'mojposaoba') {
      content = templateBa;
      html = html
        .replaceAll(`<font face=\"Arial\" size=\"2\">`, '')
        .replaceAll(`</font>`, '')
        .replaceAll(`<span style="font-family: Arial; font-size: small;">`, '<span>');
    }
    content = content
      .replace('{{theme}}', siteTheme.theme)
      .replace('{{html}}', html)
      .replaceAll(/\s/g, ' ');
    return content;
  }

  const initIframe = () => {
    if (props.iframe && iframeRef.value && iframeRef.value.contentWindow?.document?.body) {
      const width = iframeRef.value.parentElement?.clientWidth;
      const height = iframeRef.value.contentWindow?.document.body.scrollHeight;

      if (width && height) {
        iframeRef.value.width = width + '';
        iframeRef.value.height = height + '';
      }
    }
  };

  const initIframeDebounced = useDebounceFn(initIframe, 300);

  watch(iframeRef, initIframeDebounced, { immediate: true });
  watch(() => windowWidth.value, useDebounceFn(initIframeDebounced, 200));
  watch(() => windowWidth.value, useThrottleFn(initIframeDebounced, 200));
</script>

<template>
  <iframe
    v-if="iframe"
    ref="iframeRef"
    :srcdoc="innerHtml"
    frameborder="0"
    width="100%"
    scrolling="no"
    style="width: 100%; transition: height 400ms"
    @load="initIframeDebounced"
  />
  <div
    v-else
    v-html="innerHtml"
  />
</template>
